import { WPBlock } from "../../../blocks/model/WPBlocks";
import PostAgenturenList from "./PostAgenturenList";
import PostGallery from "./PostGallery";

interface BlockManagerProps {
  blocks: WPBlock[];
  postEventBanner: any;
}

function PostBlockManager({ blocks, postEventBanner }: BlockManagerProps) {
  return (
    <>
      {blocks.map((block, index) => {
        switch (block.name) {
          case "core/gallery":
            return (
              <PostGallery key={block.name + index} block={block}></PostGallery>
            );
          case "custom/eventbanner":
            return <div key={"banner" + index}> {postEventBanner}</div>;
          case "lazyblock/fotos-agenturen-block":
            return (
              <PostAgenturenList key={"agenturen" + index} agenturen={block} />
            );
          case "core/freeform":
            return (
              <div
                key={block.name + index}
                dangerouslySetInnerHTML={{
                  __html: block.originalContent,
                }}
              ></div>
            );
          default:
            return (
              <div
                key={block.name + index}
                dangerouslySetInnerHTML={{
                  __html: block.originalContent,
                }}
              ></div>
            );
        }
      })}
    </>
  );
}

export default PostBlockManager;
